"use strict";
// tslint:disable
/**
 * Microtica Elasticsearch Microservice
 * API for Elasticsearch Microservice
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsElasticsearchApi = exports.MsElasticsearchApiFactory = exports.MsElasticsearchApiFp = exports.MsElasticsearchApiAxiosParamCreator = exports.StageDeploymentComponentCloudProviderEnum = exports.StageDeploymentComponentInfrastructureAsCodeToolEnum = exports.StageDeploymentComponentTypeEnum = exports.GetDeploymentHistoryQueryTypeEnum = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var GetDeploymentHistoryQueryTypeEnum;
(function (GetDeploymentHistoryQueryTypeEnum) {
    GetDeploymentHistoryQueryTypeEnum["Stage"] = "stage";
    GetDeploymentHistoryQueryTypeEnum["Service"] = "service";
    GetDeploymentHistoryQueryTypeEnum["All"] = "all";
})(GetDeploymentHistoryQueryTypeEnum = exports.GetDeploymentHistoryQueryTypeEnum || (exports.GetDeploymentHistoryQueryTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var StageDeploymentComponentTypeEnum;
(function (StageDeploymentComponentTypeEnum) {
    StageDeploymentComponentTypeEnum["Kubernetes"] = "kubernetes";
    StageDeploymentComponentTypeEnum["Database"] = "database";
    StageDeploymentComponentTypeEnum["Storage"] = "storage";
    StageDeploymentComponentTypeEnum["VirtualMachine"] = "virtual-machine";
    StageDeploymentComponentTypeEnum["Lambda"] = "lambda";
    StageDeploymentComponentTypeEnum["Vpc"] = "vpc";
    StageDeploymentComponentTypeEnum["Other"] = "other";
})(StageDeploymentComponentTypeEnum = exports.StageDeploymentComponentTypeEnum || (exports.StageDeploymentComponentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var StageDeploymentComponentInfrastructureAsCodeToolEnum;
(function (StageDeploymentComponentInfrastructureAsCodeToolEnum) {
    StageDeploymentComponentInfrastructureAsCodeToolEnum["Terraform"] = "terraform";
    StageDeploymentComponentInfrastructureAsCodeToolEnum["Cloudformation"] = "cloudformation";
})(StageDeploymentComponentInfrastructureAsCodeToolEnum = exports.StageDeploymentComponentInfrastructureAsCodeToolEnum || (exports.StageDeploymentComponentInfrastructureAsCodeToolEnum = {}));
/**
    * @export
    * @enum {string}
    */
var StageDeploymentComponentCloudProviderEnum;
(function (StageDeploymentComponentCloudProviderEnum) {
    StageDeploymentComponentCloudProviderEnum["Aws"] = "aws";
    StageDeploymentComponentCloudProviderEnum["Azurerm"] = "azurerm";
    StageDeploymentComponentCloudProviderEnum["Google"] = "google";
})(StageDeploymentComponentCloudProviderEnum = exports.StageDeploymentComponentCloudProviderEnum || (exports.StageDeploymentComponentCloudProviderEnum = {}));
/**
 * MsElasticsearchApi - axios parameter creator
 * @export
 */
var MsElasticsearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getDeployedMicroservices.');
            }
            // verify required parameter 'kubernetesId' is not null or undefined
            if (kubernetesId === null || kubernetesId === undefined) {
                throw new base_1.RequiredError('kubernetesId', 'Required parameter kubernetesId was null or undefined when calling getDeployedMicroservices.');
            }
            var localVarPath = "/search/deployed-microservices";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (kubernetesId !== undefined) {
                localVarQueryParameter['kubernetesId'] = kubernetesId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get deployments for project - unified endpoint for stage, service, or both
         * @param {string} projectId
         * @param {GetDeploymentHistoryQuery} [getDeploymentHistoryQuery] Query parameters for filtering deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentHistory: function (projectId, getDeploymentHistoryQuery, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getDeploymentHistory.');
            }
            var localVarPath = "/search/deployments";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof getDeploymentHistoryQuery !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(getDeploymentHistoryQuery !== undefined ? getDeploymentHistoryQuery : {}) : (getDeploymentHistoryQuery || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getDeploymentTime.');
            }
            var localVarPath = "/search/deployment-time";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (stageId !== undefined) {
                localVarQueryParameter['stageId'] = stageId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get number of deployments
         * @param {string} projectId
         * @param {'stage' | 'service'} entityType Type of entity
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfDeployments: function (projectId, entityType, id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getNumberOfDeployments.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new base_1.RequiredError('entityType', 'Required parameter entityType was null or undefined when calling getNumberOfDeployments.');
            }
            var localVarPath = "/search/{entityType}/number-of-deployments"
                .replace("{".concat("entityType", "}"), encodeURIComponent(String(entityType)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getPipelineMetrics.');
            }
            var localVarPath = "/search/pipeline-metrics";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (pipelineId !== undefined) {
                localVarQueryParameter['pipelineId'] = pipelineId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MsElasticsearchApiAxiosParamCreator = MsElasticsearchApiAxiosParamCreator;
/**
 * MsElasticsearchApi - functional programming interface
 * @export
 */
var MsElasticsearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getDeployedMicroservices(projectId, kubernetesId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get deployments for project - unified endpoint for stage, service, or both
         * @param {string} projectId
         * @param {GetDeploymentHistoryQuery} [getDeploymentHistoryQuery] Query parameters for filtering deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentHistory: function (projectId, getDeploymentHistoryQuery, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getDeploymentHistory(projectId, getDeploymentHistoryQuery, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getDeploymentTime(projectId, stageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get number of deployments
         * @param {string} projectId
         * @param {'stage' | 'service'} entityType Type of entity
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfDeployments: function (projectId, entityType, id, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getNumberOfDeployments(projectId, entityType, id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getPipelineMetrics(projectId, pipelineId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.MsElasticsearchApiFp = MsElasticsearchApiFp;
/**
 * MsElasticsearchApi - factory interface
 * @export
 */
var MsElasticsearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getDeployedMicroservices(projectId, kubernetesId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get deployments for project - unified endpoint for stage, service, or both
         * @param {string} projectId
         * @param {GetDeploymentHistoryQuery} [getDeploymentHistoryQuery] Query parameters for filtering deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentHistory: function (projectId, getDeploymentHistoryQuery, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getDeploymentHistory(projectId, getDeploymentHistoryQuery, options)(axios, basePath);
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getDeploymentTime(projectId, stageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get number of deployments
         * @param {string} projectId
         * @param {'stage' | 'service'} entityType Type of entity
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfDeployments: function (projectId, entityType, id, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getNumberOfDeployments(projectId, entityType, id, options)(axios, basePath);
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getPipelineMetrics(projectId, pipelineId, options)(axios, basePath);
        },
    };
};
exports.MsElasticsearchApiFactory = MsElasticsearchApiFactory;
/**
 * MsElasticsearchApi - object-oriented interface
 * @export
 * @class MsElasticsearchApi
 * @extends {BaseAPI}
 */
var MsElasticsearchApi = /** @class */ (function (_super) {
    __extends(MsElasticsearchApi, _super);
    function MsElasticsearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get deployed microservice
     * @param {string} projectId
     * @param {string} kubernetesId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getDeployedMicroservices = function (projectId, kubernetesId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getDeployedMicroservices(projectId, kubernetesId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get deployments for project - unified endpoint for stage, service, or both
     * @param {string} projectId
     * @param {GetDeploymentHistoryQuery} [getDeploymentHistoryQuery] Query parameters for filtering deployments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getDeploymentHistory = function (projectId, getDeploymentHistoryQuery, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getDeploymentHistory(projectId, getDeploymentHistoryQuery, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get terraform deployment time
     * @param {string} projectId
     * @param {string} [stageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getDeploymentTime = function (projectId, stageId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getDeploymentTime(projectId, stageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get number of deployments
     * @param {string} projectId
     * @param {'stage' | 'service'} entityType Type of entity
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getNumberOfDeployments = function (projectId, entityType, id, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getNumberOfDeployments(projectId, entityType, id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Search Pipeline Metrics
     * @param {string} projectId
     * @param {string} [pipelineId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getPipelineMetrics = function (projectId, pipelineId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getPipelineMetrics(projectId, pipelineId, options)(this.axios, this.basePath);
    };
    return MsElasticsearchApi;
}(base_1.BaseAPI));
exports.MsElasticsearchApi = MsElasticsearchApi;
//# sourceMappingURL=api.js.map